import Typography from '@elementor/ui/Typography';
import PropTypes from 'prop-types';
import {
	StyledListItemContent,
	StyledListItemLevelBox,
	StyledListItemTopWrapper,
} from '@styles/heading-structure.styles';
import { HEADING_STATUS, HEADING_STATUS_DESCRIPTION } from '@types/heading';
import { STATUS_CONFIG } from '../../constants';

const HeadingTreeListItemTopWrapper = ({
	id,
	status,
	level,
	displayLevel,
	content,
	isExpanded,
	toggleHeading,
}) => {
	const config = STATUS_CONFIG[status];
	const IconComponent = config.icon;

	const onHeadingClick = () => {
		toggleHeading();
	};

	return (
		<StyledListItemTopWrapper
			level={level}
			onClick={onHeadingClick}
			isExpanded={isExpanded}
			aria-expanded={isExpanded}
			aria-controls={id}
			aria-invalid={HEADING_STATUS.SUCCESS !== status}
			aria-description={HEADING_STATUS_DESCRIPTION[status]}
		>
			<StyledListItemLevelBox status={status}>
				<Typography as="span" variant="subtitle2">
					{displayLevel.toUpperCase()}
				</Typography>
			</StyledListItemLevelBox>

			<StyledListItemContent level={level} as="span" variant="body2">
				{content}
			</StyledListItemContent>

			<IconComponent color={config.iconColor} fontSize="small" />
		</StyledListItemTopWrapper>
	);
};

HeadingTreeListItemTopWrapper.propTypes = {
	id: PropTypes.string.isRequired,
	status: PropTypes.oneOf(Object.values(HEADING_STATUS)).isRequired,
	level: PropTypes.number.isRequired,
	displayLevel: PropTypes.string.isRequired,
	content: PropTypes.string.isRequired,
	isExpanded: PropTypes.bool.isRequired,
	toggleHeading: PropTypes.func.isRequired,
};

export default HeadingTreeListItemTopWrapper;
